// Data management otherWebsite 模块 url 地址管理
export const url = {
    topRanking: '/auth/topRankingSource/findListForFilter',  // 查询topranking列表
    topRankingfindListForFilter: '/auth/topRankingSource/findListForFilter', 
    faceList: '/auth/topRanking/findList',
    topRankingSegment: '/auth/trendCategory/findFilterByPid', // 分类列表
    topRankingSourceupdate: '/manage/topRankingSource/update', // 更新网站来源
    topRankingSourcefindList: '/manage/topRankingSource/findList', // 查询网站来源列表
    topRankingSourcesave: '/manage/topRankingSource/save' , // 保存网站来源
    topRankingSourceupdateStatus: '/manage/topRankingSource/updateStatus', // 更新网站状态
    topRankingsave: '/manage/topRanking/save', // 保存topranking 数据
    topRankingupdate: '/manage/topRanking/update', // 更新topranking 数据
    topRankingfind: '/manage/topRanking/find', // 查询topranking
    topRankingfindList: '/manage/topRanking/findList', // 查询topranking列表
    topRankingupdateStatus: '/manage/topRanking/updateStatus',
    findByParentId: '/auth/dictionaries/findByParentId'
}


// WEBPACK FOOTER //
// ./src/axios/api_urls/otherWebsite.js